export default __webpack_public_path__ + "static/HeroSectionRight_uk-5219524b36e26d9c8626db5e7325f9b0.png";